import { CommonModule } from '@angular/common';
import {
    Component,
    HostListener,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'app-calendar-scroll-to-top',
    templateUrl: './calendar-scroll-to-top.component.html',
    styleUrls: ['./calendar-scroll-to-top.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule],
})
export class CalendarScrollToTopComponent {
    @Input() minScroll: number;
    @Input() scrollTo: number;

    @HostListener('window:scroll', [])
    onWindowScroll() {
        const minScroll = this.minScroll || 3300;
        const toTop = document.querySelector('.to-top');
        if (window.pageYOffset > minScroll) {
            toTop.classList.add('active');
        } else {
            toTop.classList.remove('active');
        }
    }

    scrollToTop() {
        window.scrollTo(0, this.scrollTo || 2500);
    }
}
